export const GET_LISTINGS_PENDING = 'getListingsPending';
export const GET_LISTINGS_FULFILLED = 'getListingsFulfilled';
export const GET_LISTINGS_REJECTED = 'getListingsRejected';
